import React from 'react';
export default function ListEmptyPlaceholder(_a) {
    var placeholder = _a.placeholder;
    return (React.createElement("div", { className: "flex-layout-center-h color-gray", style: {
            lineHeight: '80px',
            fontSize: 14,
        } },
        React.createElement("span", null, placeholder)));
}
//# sourceMappingURL=index.js.map